import React from "react";

export default function footer() {
  const year = new Date().getFullYear();
  return (
    <footer style={{ bottom: 0, height: "auto", textAlign: "center" }}>
      <p>{year} Copyright Hamzah Aldolaay</p>
    </footer>
  );
}
